import { useMutation } from "react-query";
import paths from "API/paths";
import axiosInstance from "Services/axiosConfig";

interface DeleteSegmentValuePayloadP {
  projectId: string;
  segmentId: string;
  contextId: string;
  contextValues: string[];
}

const deleteSegmentValue = async (payload: DeleteSegmentValuePayloadP) => {
  try {
    const url = paths.deleteSegmentValue();
    const response = await axiosInstance.post(url, { input: payload });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const useDeleteSegmentValue = () => {
  return useMutation(deleteSegmentValue);
};
